import { IconSvgElement } from "@hugeicons/react";

export const InformationDiamondIcon: IconSvgElement = [
  [
    "path",
    {
      d: "M15.152 4.2856C13.9782 3.85 13.4569 2.1063 12.119 2.006C12.0396 2.0001 11.9595 2.0001 11.88 2.006C10.5421 2.1063 10.0209 3.8499 8.847 4.2856C7.604 4.7468 5.9044 3.8014 4.8519 4.854C3.8389 5.867 4.7353 7.6315 4.2836 8.849C3.8218 10.0931 1.8906 10.6076 2.004 12.1211C2.1043 13.459 3.8479 13.9801 4.2836 15.1541C4.7354 16.3716 3.8388 18.1362 4.8519 19.1491C5.9043 20.2016 7.604 19.2566 8.847 19.7174C10.0206 20.1538 10.5423 21.8969 11.88 21.9971C11.9595 22.0031 12.0396 22.0031 12.119 21.9971C13.4568 21.8969 13.9784 20.1536 15.152 19.7174C16.3696 19.2661 18.1343 20.1623 19.1472 19.1491C20.2344 18.0622 19.1868 16.2997 19.7612 15.0436C20.2921 13.8871 22.1054 13.3456 21.995 11.8821C21.895 10.5443 20.1517 10.0226 19.7154 8.849C19.2547 7.606 20.1996 5.9063 19.1472 4.854C18.0947 3.8014 16.395 4.7468 15.152 4.2856Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      key: "0"
    }
  ],
  [
    "path",
    {
      d: "M12.243 16.0015V12.0016C12.243 11.5302 12.243 11.2945 12.0965 11.148C11.9501 11.0016 11.7144 11.0016 11.243 11.0016",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "1"
    }
  ],
  [
    "path",
    {
      d: "M11.993 8.0016H12.0019",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "2"
    }
  ]
];
